import { useContext, useMemo, useState } from "react";
import { ClickAwayListener } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import AppContext from "AppContext";
import styled, { css } from "styled-components";
import ToolDropdown from "views/tools/ToolDropdown";
import ToolTabs from "views/tools/ToolTabs";
import ToolContent from "views/tools/ToolContent";
import BhatikaIcon from "assets/bhatika.png";

export default function Tools() {
  const { platformUser } = useContext(AppContext);
  const userImage = platformUser?.user_metadata?.avatar_url;
  const [activePopup, setActivePopup] = useState(null); // null, 'ai', or tool object
  const [$openToolsList, set$openToolsList] = useState(false);

  const tabs = useMemo(() => {
    const toolItems = {
      // 1: {
      //   text: "🔐 Admin Console",
      //   subtitle: "Manage your orgnization & team",
      //   width: "tablet",
      //   showFilters: false,
      // },
      // 2: {
      //   text: "🗣️ Announcments",
      //   subtitle: "News and announcements",
      //   width: "tablet",
      //   showFilters: false,
      // },
      // 3: {
      //   text: "💵 Funding",
      //   subtitle: "Explore funding opportunities",
      //   width: "tablet",
      //   showFilters: false,
      // },
    };

    const stateTabs = [];
    for (let index = 1; toolItems[index]; index++) {
      stateTabs.push({
        text: toolItems[index].text,
        subtitle: toolItems[index].subtitle,
        width: toolItems[index].width,
        showFilters: toolItems[index].showFilters,
      });
    }
    return stateTabs;
  }, []);

  const options = [
    ...tabs,
    {
      text: "Help",
      width: "mobile",
      showFilters: true,
    },
  ];

  const handleClickSelect = () => {
    if (activePopup) {
      setActivePopup(null);
      set$openToolsList(false);
    } else {
      set$openToolsList(!$openToolsList);
    }
  };

  const handleOnClickTool = (tab) => {
    const isClosing = activePopup && tab.text === activePopup.text;
    
    if (isClosing) {
      setActivePopup(null);
    } else {
      setActivePopup(tab);
    }
    set$openToolsList(false);
  };

  const handleBhatikaClick = (e) => {
    e.stopPropagation();
    
    // If AI Chat is open, close it
    if (activePopup === 'ai') {
      setActivePopup(null);
    } else {
      // Open AI chat
      setActivePopup('ai');
    }
  };

  const aiTool = {
    text: "",
    subtitle: "Ask anything.",
    width: "tablet",
    showFilters: false,
    component: "AIChat",
  };

  const currentTool = activePopup === 'ai' ? aiTool : activePopup;

  return (
    <ClickAwayListener onClickAway={() => set$openToolsList(false)}>
      <ToolsContainer className="ToolsContainer">
        <ToolsContent
          className="ToolsContent"
          $openToolsList={$openToolsList}
          $openPopup={!!activePopup}
        >
          <ToolTabs
            className="ToolTabs"
            tabs={tabs}
            tabValue={activePopup?.text}
            handleOnClick={handleOnClickTool}
          />
          <MobileContainer className="MobileTools">
            <ToolDropdown
              className="ToolDropdown"
              options={options}
              handleOnChange={handleOnClickTool}
              value={activePopup?.text}
              handleClick={handleClickSelect}
              open={$openToolsList}
              handleOnClose={() => {
                setActivePopup(null);
                set$openToolsList(false);
              }}
            />
          </MobileContainer>
          <IconContainer onClick={handleBhatikaClick} className="IconContainer">
            <span className="tool-text">{aiTool.subtitle}</span>
            <Bhatika>
              <img
                src={BhatikaIcon}
                alt="BhatikaIcon"
                style={{ width: "45px", height: "45px" }}
              />
            </Bhatika>
          </IconContainer>
          <ToolContent
            toolItem={currentTool}
            open={!!activePopup}
            handleOnClose={() => setActivePopup(null)}
          />
        </ToolsContent>
      </ToolsContainer>
    </ClickAwayListener>
  );
}


const ToolsContainer = styled.div.attrs({
  className: 'ToolsContainer'
})`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 5500;
  display: block;
  min-height: 75px;
  // transform: translateX(-50%);
`;

const ToolsContent = styled.div.attrs({
  className: 'ToolsContent'
})`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin: auto;
  font-family: serif !important;
  background: #131313;
  * {
    box-sizing: border-box;
  }
  padding: 0px 10px;
  /* make the emoji monocrhome too  */
  @media screen and (min-width: 640px) {
    padding: 0px;
    display: flex;
    align-items: center;
    height: 75px;
    justify-content: flex-end;
    padding-right: 3%;
  }

  @media screen and (max-width: 640px) {
    box-shadow: 0px 0px 5px lightgray;
    width: 100%;
    margin: auto;
    transition: width 0.3s;
    ${(props) =>
      (props.$openToolsList || props.$openPopup) &&
      css`
        width: calc(100% - 20px);
        border-radius: 5px 5px 0px 0px;
      `}
    .MuiTabs-root {
      display: none;
    }
  }
`;

const HelpIcon = styled.div.attrs({
  className: 'HelpIcon'
})`
  width: 34px;
  height: 34px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: pt sans;
  font-weight: bold;
  color: white;
  svg {
    font-size: 1.75em;
  }
  &:hover {
    color: ${(props) => props.theme.primaryColor};
  }
`;

const ToggleIcon = styled.div.attrs({
  className: 'ToggleIcon'
})`
  margin-left: 0px;
  margin-right: 10px;
  cursor: pointer;
  color: lightgrey;
  &:hover {
    color: ${(props) => props.theme.primaryColor};
  }
  svg {
    font-size: 3em;
  }
`;

const IconContainer = styled.div.attrs({
  className: 'IconContainer'
})`
  display: flex;
  align-items: center;
  margin-left: 2px;
  @media screen and (max-width: 640px) {
    display: none;
  }
  &:hover {
    cursor: pointer;
  }
  .tool-text {
    color: white;
    font-size: 12px;
    font-weight: bold;
    font-family: pt sans;
    background: #1548a2;
    padding: 10px 25px;
    border-radius: 5px;
    box-sizing: border-box;
  }
`;

const MobileContainer = styled.div.attrs({
  className: 'MobileContainer'
})`
  display: flex;
  align-items: center;
  height: 70px;
  @media screen and (min-width: 640px) {
    display: none;
  }
`;

const ProfileAvatar = styled(Avatar).attrs({
  className: 'ProfileAvatar'
})`
  width: 45px !important;
  height: 45px !important;
  margin-left: 10px;
  margin-right: 20px;
  border
`;

const Bhatika = styled.div.attrs({
  className: 'Bhatika'
})`
  margin-top: -2px;
  cursor: pointer;
  position: relative;
  animation: rotate 15s linear infinite;
  transform-origin: center center;
  img {
    transform: scale(.75);
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
